export type NoteRecipientId = number | string;

export interface NoteFilter {
    noteType: Array<number | string>;
    related: boolean;
}

export interface NotePaginatedResponse {
    comments: FetchedLeadNote[];
    total: number;
}

export type LeadNote = {
    id?: number | null;
    parent_id?: number | null;
    user_id?: NoteRecipientId | null;
    content?: string;
    private?: boolean;
    alert_users?: NoteRecipientId[];
    alert?: boolean;
    alert_sms?: boolean;
    alert_email?: boolean;
    request_user_id?: NoteRecipientId | null;
    file?: File | File[] | null;
    file_url?: string | null;
    bookmarked?: boolean;
    children?: LeadNote[];
};

export type FetchedLeadNote = Omit<LeadNote, 'alert_users' | 'children'> & {
    alert_users?: Array<NoteRecipientId | { id: NoteRecipientId }>;
    children?: FetchedLeadNote[];
};

export type NewNotePayload = {
    content: string;
    alert_users: NoteRecipientId[];
    parent_id?: number | null;
    private?: boolean;
    alert?: boolean;
    alert_sms?: boolean;
    alert_email?: boolean;
    user_id?: NoteRecipientId | null;
    request_user_id?: NoteRecipientId | null;
    file?: File | File[] | null;
};

export type AudioNotePayload = {
    key: string;
    duration: number;
    alert_users: NoteRecipientId[];
    private?: boolean;
    parentId?: number | null;
};

export const NoteSubmitType = {
    CREATE: 'create',
    UPDATE: 'update',
    AUDIO: 'audio',
} as const;

export type NoteSubmitIntent =
    | { type: typeof NoteSubmitType.CREATE; note: NewNotePayload }
    | { type: typeof NoteSubmitType.UPDATE; note: LeadNote }
    | { type: typeof NoteSubmitType.AUDIO; note: AudioNotePayload };

export const hasMoreNotes = (loadedCount: number, total: number): boolean => loadedCount < total;
